import { createApp } from '@backstage/frontend-defaults';
import searchPlugin from '@backstage/plugin-search/alpha';
import { addCollection } from '@iconify/react';
import { icons as ipenIcons } from '@ipen/icons';
import { icons as remixIcons } from '@ipen/icons/remix';

import { navigationPagesPlugin } from './modules/navigationPages';

// eslint-disable-next-line unicorn/no-top-level-side-effects
addCollection(ipenIcons);
// eslint-disable-next-line unicorn/no-top-level-side-effects
addCollection(remixIcons);

export const App = createApp({
  features: [
    navigationPagesPlugin,
    searchPlugin,
  ],
});
